import produce from "immer"

const initialState = {
    initialized: false,
    localConfig: {
        locationPermissionAsked: false,
        cameraPermissionAsked: false,
        introShown: false,
    },
}

export const reducer = produce((draft, action) => {
    switch (action.type) {
        case "INITIALIZE_APP":
            draft.initialized = false
            break
        case "FETCH_ME_SUCCESS":
            draft.initialized = true
            break
        case "FETCH_ME_FAILURE":
            draft.initialized = true
            break
        case "LOCATION_PERMISSION_ASKED":
            draft.localConfig.locationPermissionAsked = true
            break
        case "CAMERA_PERMISSION_ASKED":
            draft.localConfig.cameraPermissionAsked = true
            break
        case "LOCAL_CONFIG_LOAD":
            if (action.payload != null) {
                draft.localConfig = action.payload
            }
            break
        case "INTRO_CONFIRMED":
            draft.localConfig.introShown = true
            break
        default:
            break
    }
}, initialState)

function deRoot(state) {
    return state.app
}

export function selectAppInitialized(state) {
    return deRoot(state).initialized
}

export function selectLocalConfig(state) {
    return deRoot(state).localConfig
}

export function selectLocationPermissionAsked(state) {
    return selectLocalConfig(state).locationPermissionAsked
}

export function selectCameraPermissionAsked(state) {
    return selectLocalConfig(state).cameraPermissionAsked
}

export function selectIntroShown(state) {
    return selectLocalConfig(state).introShown
}
